import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../context/AuthContext';
import useCollection from './useCollection';
import { FaCheckCircle, FaTimesCircle, FaTrashAlt, FaPlus } from 'react-icons/fa';

const Agenda = () => {
  const { profile, currentUser } = useAuth();
  const { items: events, loading } = useCollection('agenda', 'date', true);
  const [presences, setPresences] = useState([]);
  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [type, setType] = useState('repetition');
  const [msg, setMsg] = useState('');

  const isDirectorOrAdmin = profile?.is_admin || profile?.role === 'director';

  const fetchPresences = async () => {
    const { data } = await supabase.from('agenda_presence').select('*, profiles(name)');
    if (data) setPresences(data);
  };

  useEffect(() => {
    fetchPresences();
  }, []);

  const handleStatus = async (agendaId, status) => {
    await supabase.from('agenda_presence').upsert({
      agenda_id: agendaId,
      user_id: currentUser.id,
      status,
      updated_at: new Date(),
    }, { onConflict: 'agenda_id,user_id' });

    fetchPresences();
  };

  const handleAddEvent = async (e) => {
    e.preventDefault();
    setMsg('');
    if (!title.trim() || !date) return;

    const { error } = await supabase.from('agenda').insert({
      title: title.trim(),
      date,
      type,
      added_by: profile?.name || 'Admin',
    });

    if (error) {
      setMsg("Erreur lors de l'ajout : " + error.message);
    } else {
      setTitle('');
      setDate('');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Voulez-vous supprimer cet événement ?")) {
      await supabase.from('agenda').delete().eq('id', id);
    }
  };

  return (
    <div className="membres-section">
      <h3>📅 Agenda des Répétitions & Représentations</h3>

      {isDirectorOrAdmin && (
        <form onSubmit={handleAddEvent} className="membres-inline-form" style={{ marginBottom: '20px' }}>
          <input
            type="text"
            placeholder="Titre de l'événement"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="repetition">🎭 Répétition</option>
            <option value="representation">🎟️ Représentation</option>
            <option value="autre">📌 Autre</option>
          </select>
          <button type="submit" className="membres-btn"><FaPlus /> Ajouter</button>
        </form>
      )}

      {msg && <p style={{ color: '#dc3545', marginBottom: '10px' }}>{msg}</p>}

      {loading ? (
        <p>Chargement de l'agenda...</p>
      ) : events.length === 0 ? (
        <p style={{ fontStyle: 'italic', opacity: 0.7 }}>Aucun événement prévu dans l'agenda.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {events.map((evt) => {
            const eventPresences = presences.filter((p) => p.agenda_id === evt.id);
            const myStatus = eventPresences.find((p) => p.user_id === currentUser?.id)?.status;
            const presents = eventPresences.filter((p) => p.status === 'present');
            const absents = eventPresences.filter((p) => p.status === 'absent');

            return (
              <div key={evt.id} className="info-box" style={{ position: 'relative' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <h4 style={{ margin: '0 0 5px 0' }}>{evt.title}</h4>
                    <p style={{ margin: 0 }}><strong>📅 Date :</strong> {new Date(evt.date).toLocaleDateString('fr-FR')}</p>
                  </div>
                  {isDirectorOrAdmin && (
                    <button
                      onClick={() => handleDelete(evt.id)}
                      style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }}
                      title="Supprimer l'événement"
                    >
                      <FaTrashAlt />
                    </button>
                  )}
                </div>

                {/* Boutons de présence */}
                <div style={{ marginTop: '12px', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <span style={{ fontWeight: 'bold' }}>Ma présence :</span>
                  <button
                    className="membres-btn"
                    style={{ backgroundColor: myStatus === 'present' ? '#28a745' : '#6c757d', padding: '6px 12px' }}
                    onClick={() => handleStatus(evt.id, 'present')}
                  >
                    <FaCheckCircle /> Présent(e)
                  </button>
                  <button
                    className="membres-btn"
                    style={{ backgroundColor: myStatus === 'absent' ? '#dc3545' : '#6c757d', padding: '6px 12px' }}
                    onClick={() => handleStatus(evt.id, 'absent')}
                  >
                    <FaTimesCircle /> Absent(e)
                  </button>
                </div>

                {/* Récapitulatif de la troupe */}
                <div style={{ marginTop: '10px', fontSize: '0.85rem', opacity: 0.8, borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '8px' }}>
                  <span>✅ <strong>Présents ({presents.length}) :</strong> {presents.map(p => p.profiles?.name).join(', ') || 'Aucun pour le moment'}</span>
                  <br />
                  <span>❌ <strong>Absents ({absents.length}) :</strong> {absents.map(p => p.profiles?.name).join(', ') || 'Aucun'}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Agenda;